import { render, staticRenderFns } from "./FirmClaimsTable.vue?vue&type=template&id=7b7d3088"
import script from "./FirmClaimsTable.vue?vue&type=script&lang=js"
export * from "./FirmClaimsTable.vue?vue&type=script&lang=js"
import style0 from "./FirmClaimsTable.vue?vue&type=style&index=0&id=7b7d3088&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports